'use client'

import theme from '../../theme'
import {ChakraProvider} from '@chakra-ui/react'
import {ThemeProviderProps, ThemeProvider as TProvider} from 'next-themes'

// oxlint-disable-next-line no-empty-object-type
interface ColorModeProviderProps extends ThemeProviderProps {}

function ColorModeProvider({children, ...props}: ColorModeProviderProps) {
  return (
    <TProvider attribute="class" disableTransitionOnChange forcedTheme="light" {...props}>
      {children}
    </TProvider>
  )
}

export function ThemeProvider({children, ...props}: ColorModeProviderProps) {
  return (
    <ChakraProvider value={theme}>
      <ColorModeProvider attribute="class" disableTransitionOnChange forcedTheme="light" {...props}>
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  )
}
